var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:[_vm.userTheme],attrs:{"id":"app"}},[_c('router-view'),_c('v-overlay',{attrs:{"value":_vm.loadingArray.length > 0,"z-index":"9999"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.userStyle.color,"size":"64"}})],1),_c('GlobalDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }